import List from "@/components/list";
import { tableBaseProps } from '@/utils/common.js';

const Table = (args) => {
  const { listeners, props } = args;
  const selectionChange = listeners["selectionChange"] || function () { };
  const download = listeners["download"] || function () { }
  const del = listeners["del"] || function () { };

  const Deal = ({ props: { vo } }) => {
    const { row } = vo;
    let dealConf = [
      ["iconfont ic_download iconfont-adapt", "点击下载", () => download(row), "classReportPlanFileLibrary:download"],
      ["icon-delete", "删除", () => del(row), "classReportPlanFileLibrary:delete"],
    ]

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  }
  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    tableBaseProps("文件名称", "fileName", "m220"),
    tableBaseProps("上传者", "createUserName", "120"),
    tableBaseProps("上传时间", "createDate", "180"),
    {
      label: "操作",
      fixed: "right",
      width: '130',
      render: vo => <Deal vo={vo} />
    }
  ]
  return <List {...args} talbeCols={AccountTableConfig} onSelectionChange={selectionChange} />;
}
export default Table;
